import { render, staticRenderFns } from "./PaymentCanceled.vue?vue&type=template&id=5e112f71&scoped=true&"
import script from "./PaymentCanceled.vue?vue&type=script&lang=js&"
export * from "./PaymentCanceled.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCanceled.vue?vue&type=style&index=0&id=5e112f71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e112f71",
  null
  
)

export default component.exports